import { gql } from '@apollo/client';

export const GET_TABLE_WIDGET_BIRTHDAYS = gql`
  query GetTableWidgetBirthdays($programIds: [String], $activityIds: [String]) {
    vm {
      profileBirthdays(programIds: $programIds, activityIds: $activityIds) {
          profileId
          firstName
          preferredName
          lastName
          dateOfBirth
          userId
      }
    }
  }
`;
